import React from 'react' // required for using JSX
import { Step } from 'react-joyride'
import { ArrowBack, ArrowForward } from '@material-ui/icons'

import { IUser } from 'types'

const iconStyles = { verticalAlign: 'middle', display: 'inline-block' }

export const introTutorialSteps: (user: IUser | null | undefined, isMobile?: boolean) => Step[] = (
  user,
  isMobile = false
) => {
  const steps: Step[] = [
    {
      target: 'body',
      title: <>Welcome to 5G Innovation Sessions.</>,
      content: 'Learn how to make the most of your experience with us.',
      // disableBeacon: true,
      placement: 'center',
      locale: { next: `Let's get started` }
    },
    {
      target: isMobile ? '#mobileMenu' : '#homeButton',
      title: 'Main menu',
      content:
        'The menu allows you to access event information, support, contact information and platform navigation. You can also revisit the tutorial at any time.',
      // disableBeacon: true,
      placement: 'auto'
    },
    {
      target: 'body',
      title: 'Navigating content',
      content: isMobile ? (
        <span>
          To start navigating, swipe the content posters from right to left. Click <strong>Finish</strong> to return to
          the welcome page.
        </span>
      ) : (
        <span>
          To start, use the <ArrowBack style={iconStyles} />{' '}
          <strong style={{ ...iconStyles, marginRight: '8px' }}>Prev</strong> <strong style={iconStyles}>Next</strong>{' '}
          <ArrowForward style={iconStyles} /> buttons below to navigate through the content posters. Click{' '}
          <strong>Finish</strong> to return to the welcome page.
        </span>
      ),
      // disableBeacon: true,
      placement: 'center'
    }
  ]
  return steps
}
